Utils.prototype.badge = function(u) {
    switch (u) {
        case 'username':
            return 'https://mobcpop.com/badge/star.png'
        case 'vish':
            return 'https://mobcpop.com/badge/graysimp.gif'
        case 'Tiks':
            return 'https://mobcpop.com/badge/tiks5.gif'
        case 'Souly':
            return 'https://mobcpop.com/badge/souly.gif'
        case 'Matty J':
            return 'https://mobcpop.com/badge/invisible.png'
        case 'shem':
            return 'https://mobcpop.com/badge/monkey.gif'
        case 'Luisa':
            return 'https://mobcpop.com/badge/luisa3.gif'
        case 'Captain barnacles':
            return 'https://mobcpop.com/badge/captain.gif'
        case 'cynthiatx3':
            return 'https://mobcpop.com/badge/cyn2.gif'
        case '🦥ANGRYASSsLOTH':
        case '🦥angryass神天':
            return 'https://mobcpop.com/badge/pardis.gif'
        case 'NOOB':
            var date = new Date(),
                utc = date.getTime() + date.getTimezoneOffset() * 60000
            if (new Date(utc + 3600000 * 2).getDay() == 5)
                return 'https://mobcpop.com/badge/noob-rainbow.gif'
            else return 'https://mobcpop.com/badge/noob-gray.gif'
        case 'FOXYLady':
            return 'https://mobcpop.com/badge/foxy2.gif'
        case 'Airtothebanana':
            return 'https://mobcpop.com/badge/creep.png'
        case 'bxzprincessa':
            return 'https://mobcpop.com/badge/noobbxz.gif'
        case '--jamal--':
            return 'https://mobcpop.com/badge/habibi.png'
        case 'marroquin44':
        case 'Kazoo':
        case 'Slushy':
        case 'Yoshi':
            return 'https://mobcpop.com/badge/salvy.gif'
        case 'Cestl.avi':
            return 'https://mobcpop.com/badge/poop.png'
        case 'Kev':
            return 'https://mobcpop.com/badge/kev.gif'
        case 'Kozz':
            return 'https://mobcpop.com/badge/star-gold.png'
        case 'mobcpop.com':
            return 'https://mobcpop.com/badge/admin.png?1'
        default:
            return 'https://mobcpop.com/badge/star.png'
    }
}

function verified(username) {
    switch (username) {
        case 'Kev':
        case 'Zeus':
        case 'Trev': {
            return <img alt = "🖼"
            src = "/img/verified.png"
            className = "verified"
            title = "verified xD" / >
        }
        case 'Matty J': {
            return <img alt = "🖼"
            src = "/img/mattybadge.gif"
            className = "verified"
            title = "legendary" / >
        }
        case 'Bleh': {
            return ( <
                img alt = "🖼"
                src = "https://mobcpop.com/img/icon/s/ttm.gif#32"
                className = "verified"
                title = "blah" /
                >
            )
        }
        case 'FOXYlady': {
            return '🦊'
        }
    }
    return null
}

function profile_video_star(username) {
    var video = null
    switch (username) {
        case 'username': {
            video = null
            break
        }
    }
    if (video != null) {
        return <Video src = {
            video
        }
        key = {
            video
        }
        autoPlay loop className = "profile-video-star" / >
    }
    return null
}

function is_typing_text(username, typingText) {
    if (typingText == undefined || typingText == 'undefined') {
        return username + ' is typing...'
    }

    if (typingText != '' && typingText != 'is typing...' && typingText != 'undefined') {
        return username + ' ' + typingText
    } else {
        switch (username) {
            case 'FOXYLady': {
                return username + ' is purring…'
                break
            }
            default: {
                return username + ' is typing…'
            }
        }
    }
}

function is_singing_text(username) {
    switch (username) {
        case 'username': {
            return username + ' is recording…'
            break
        }
        case 'Tito': {
            return username + ' is singing…'
            break
        }
        default: {
            return username + ' is recording…'
        }
    }
}